import type { Profile, TaskType, UUID } from "@/core/types";
import type { RootState } from "@/lib/types/state";

export const selectProfile = (state: RootState): Profile | undefined => {
  return state?.auth?.profile;
};

export const selectPatientId = (state: RootState): undefined | UUID => {
  return state?.auth?.profile?.username;
};

export const selectRole = (state: RootState): null | string | undefined => {
  return state?.auth?.role;
};

export const selectTaskIdByType = (state: RootState, taskType: TaskType): undefined | UUID => {
  const tasks = state?.auth?.profile?.tasks;
  const task = tasks?.find((task) => task.task_type === taskType);

  return task?.task_id;
};
